import { ActionTypeEnum } from '../ActionTypeEnum';

// getting current store item
const supplierInfoActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.supplier_info_request,
	payload,
	meta,
});

const supplierInfoActionSuccess = (payload) => ({
	type: ActionTypeEnum.supplier_info_success,
	payload,
});

// similar
const similarSuppliersActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.similar_suppliers_request,
	payload,
	meta,
});

const similarSuppliersActionSuccess = (payload) => ({
	type: ActionTypeEnum.similar_suppliers_success,
	payload,
});

// branch
const branchActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.branch_request,
	payload,
	meta,
});

const branchActionSuccess = (payload) => ({
	type: ActionTypeEnum.branch_success,
	payload,
});

// widgets
const widgetsActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.widget_request,
	payload,
	meta,
});

const widgetsActionSuccess = (payload) => ({
	type: ActionTypeEnum.widget_success,
	payload,
});

// getInstallment
const getInstallmentActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.installment_request,
	payload,
	meta,
});

const getInstallmentActionSuccess = (payload) => ({
	type: ActionTypeEnum.installment_success,
	payload,
});

export {
	supplierInfoActionRequest,
	supplierInfoActionSuccess,
	similarSuppliersActionRequest,
	similarSuppliersActionSuccess,
	branchActionRequest,
	branchActionSuccess,
	widgetsActionRequest,
	widgetsActionSuccess,
	getInstallmentActionRequest,
	getInstallmentActionSuccess,
};
